import {autorun} from 'mobx';
import {ELEMENT_NOT_FOUND, LANGUAGES} from 'app/utils/Consts';
import {userStore, configStore} from 'app/store/global';

const CYRILLIC_LANGS = [
    'am',
    'az',
    'by',
    'ge',
    'kg',
    'md',
    'ru',
    'tm',
    'tj',
    'ua',
    'uz'
];

export const defaultChatLang = async(): Promise<string[]> => {
    if (!configStore.loaded) {
        await new Promise<void>(resolve => {
            if (configStore.loaded) {
                resolve();
                return;
            }

            const dispose = autorun(() => {
                if (configStore.loaded) {
                    dispose();
                    resolve();
                }
            });
        });
    }

    const lang = [LANGUAGES.EN];

    if (configStore.CURRENT_LOCALE === 'ru' ||
        CYRILLIC_LANGS.indexOf(userStore.user.country_code) !== ELEMENT_NOT_FOUND) {
        lang.unshift('ru');
    }
    return lang;
};
